import React from "react";
import {
  AHIcon,
  AHInput,
  AHInputProps,
  Box,
  Space,
  TouchableBox,
  useLayoutContext,
} from "arkh";
import { ActivityIndicator, TextInput, View } from "react-native";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { useHotkeys } from "../../useHotKeys";

export function OrgSearchInput(
  props: AHInputProps & {
    isLoading?: boolean;
    mode?: "default" | "integrated" | "standalone";
    onCancelSearch?: () => void;
  }
) {
  useHotkeys(
    "meta+f",
    () => {
      inputRef.current?.focus();
    },
    {
      preventDefault: true,
      enableOnContentEditable: true,
    }
  );

  const inputRef = React.useRef<TextInput>(null);
  const intl_tokens = useIntlTokens();
  const layout = useLayoutContext();

  const placehodler = props.placeholder ?? intl_tokens.Search;

  const space: Space = "xsmall";
  const roundedTop = props.mode === "integrated" ? "none" : "large";
  const roundedBottom = props.mode === "standalone" ? "large" : "none";
  return (
    <Box insets={{ top: 1 }}>
      <Box
        color="surface"
        cornerRadiusTopRight={roundedTop}
        cornerRadiusTopLeft={roundedTop}
        cornerRadiusBottomRight={roundedBottom}
        cornerRadiusBottomLeft={roundedBottom}
        space={space}
        borderColor="border-primary"
        style={
          props.mode === "integrated"
            ? undefined
            : {
                borderWidth: 1,
              }
        }
      >
        <AHInput
          ref={inputRef}
          clearButtonMode="never"
          color="surface-primary"
          borderColor="border-primary"
          textType="title-small"
          onKeyPress={(e) => {
            if (e.nativeEvent.key === "Escape") {
              props.onChangeText?.("");
              props.onCancelSearch?.();
              inputRef.current?.blur();
            }
          }}
          style={{
            padding: layout.space.small,

            borderRadius: layout.radius.large - layout.space[space],
            paddingLeft: layout.space.large,
          }}
          placeholder={placehodler}
          {...props}
        />
        <View
          pointerEvents="none"
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            top: 0,
            width: layout.space.large,

            alignItems: "center",
            flexDirection: "row-reverse",
          }}
        >
          <AHIcon
            spaceLeft="medium"
            type="search"
            color="text-washed"
            size="medium"
          />
        </View>

        {(props.value?.length ?? 0) > 0 ? (
          <TouchableBox
            spaceLeft="small"
            spaceRight="medium"
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              top: 0,
              alignItems: "center",
              flexDirection: "row",
            }}
            onPress={() => {
              props.onChangeText?.("");
              props.onCancelSearch?.();
            }}
          >
            {props.isLoading ? (
              <ActivityIndicator size="small" color="#000" />
            ) : null}
            <AHIcon
              spaceLeft="small"
              type="clear"
              color="text-washed"
              size="large"
            />
          </TouchableBox>
        ) : null}
      </Box>
    </Box>
  );
}
